import React from 'react';
import VERSION from '../../../../version';
import { AlertMessage } from 'hyperdb-utils';

const About = () => {
  return (
    <div className="content-wrapper">
      <section className="content-header content-header-fixed">
      </section>
      <section className="content content-fixed">
        <b>Rentaleo PMS version {VERSION}</b>
      </section>
    </div>
  );
};

export default About;



// WEBPACK FOOTER //
// ./src/frontend/modules/help/containers/About.jsx